/**
 * カレンダー週切り替え
 * PC: 14日（2週間）表示・2週単位で切り替え
 * SP: 全日付を横スクロール（週ナビなし・Figma 5111:32530）
 */

const BP_MD = 768; // @include md の閾値

// 当日マス（電話予約）の SP / PC 判定。列数制御の BP_MD とは別物なので混ぜないこと。
// 値は _input-calendar-col.scss / _detail_fix-contact.scss の mq-max(1000px) と揃える
const BP_TEL = 1000;

class InputCalendar {
    constructor(root) {
        this.root    = root;
        this.cols    = Array.from(root.querySelectorAll('.c-forms-input-calendar-col'));
        this.btnPrev = root.querySelector('.js-calendar-prev');
        this.btnNext = root.querySelector('.js-calendar-next');

        this.mq = window.matchMedia(`(max-width: ${BP_MD}px)`);
        this.mq.addEventListener('change', () => {
            this.offset = 0;
            this.render();
        });

        const checkedIndex = this.cols.findIndex(
            (col) => col.querySelector('.c-forms-input-calendar-col__radio:checked')
        );
        this.offset = checkedIndex >= 0 ? Math.floor(checkedIndex / this.step()) : 0;

        this.btnPrev?.addEventListener('click', () => {
            this.offset = Math.max(0, this.offset - 1);
            this.render();
        });

        this.btnNext?.addEventListener('click', () => {
            this.offset = Math.min(this.maxOffset(), this.offset + 1);
            this.render();
        });

        this.render();
    }

    isSp() {
        return this.mq.matches;
    }

    visibleCount() {
        return this.isSp() ? 7 : 14;
    }

    step() {
        return this.visibleCount();
    }

    maxOffset() {
        return Math.max(0, Math.ceil((this.cols.length - this.visibleCount()) / this.step()));
    }

    render() {
        // SP: 全列表示＋横スクロール（週ページングしない）
        if (this.isSp()) {
            this.cols.forEach((col) => col.removeAttribute('data-hidden'));
            return;
        }

        const start = this.offset * this.step();
        const end   = start + this.visibleCount();

        this.cols.forEach((col, i) => {
            col.toggleAttribute('data-hidden', i < start || i >= end);
        });

        if (this.btnPrev) this.btnPrev.disabled = this.offset === 0;
        if (this.btnNext) this.btnNext.disabled = this.offset >= this.maxOffset();
    }
}

/**
 * PCでは当日マスの tel: を開かせない（OSのアプリ選択が出るだけで混乱のもと）。
 * CSSの pointer-events で殺すと :hover まで死んで番号の吹き出しが出せないので、
 * ポインタは受けたまま「遷移だけ」をここで止める。
 * /detail/{id} はカレンダーを2回描画するため document への委譲で全件に効かせる。
 */
let telGuardBound = false;

const bindTelClickGuard = () => {
    if (telGuardBound) return;
    telGuardBound = true;

    // SP判定はCSSと同じ max-width。境界の小数幅でPC扱いになるズレを作らない
    const mqSp = window.matchMedia(`(max-width: ${BP_TEL}px)`);

    document.addEventListener('click', (e) => {
        if (mqSp.matches) return; // SPはタップで発信させる
        if (!e.target?.closest) return;
        if (!e.target.closest('.c-forms-input-calendar-col[data-type="tel"]')) return;
        e.preventDefault();
    });
};

const main = () => {
    bindTelClickGuard();
    document.querySelectorAll('.c-forms-input-calendar').forEach((root) => {
        new InputCalendar(root);
    });
};

export default main;
